// extracted by mini-css-extract-plugin
module.exports = {"alpWrapper":"Auction_alpWrapper__2K2H-","alpContentCol":"Auction_alpContentCol__551pQ","auctionActivityCol":"Auction_auctionActivityCol__3U2jw"};